import { UnknownSenderText } from '../strings.locstring.json';
import loc from 'owa-localize';

// The sender might have the "Foo Bar <foo@bar.com>;" format
export function getSenderDisplayName(sender: string): string {
    if (!sender) {
        return loc(UnknownSenderText);
    }

    const start: number = sender.lastIndexOf('<');
    if (start <= 0) {
        return sender;
    }

    return sender.substr(0, start).trim();
}
